module.exports = __webpack_public_path__ + "2663d4799fa437b18f8580d215d822b3.svg";